import clsx from 'clsx'

import type { TextProps } from '@wartek-id/text-v1'
import { Text } from '@wartek-id/text-v1'

import type { HTMLAttributes } from 'react'

type DescriptionListProps = HTMLAttributes<HTMLDListElement> & {
  labelledById: string
}
export function DescriptionList({
  labelledById,
  children,
  ...props
}: DescriptionListProps) {
  return (
    <dl role="group" aria-labelledby={labelledById} {...props}>
      {children}
    </dl>
  )
}

type DescriptionListItemProps = HTMLAttributes<HTMLDivElement> & {
  label: string
  value: string
}
export function DescriptionListItem({
  label,
  value,
  className,
  ...props
}: DescriptionListItemProps) {
  const labelId = `description-list-item-${label
    .replace(/\s+/g, '-')
    .toLowerCase()}`

  return (
    <div
      className={clsx('flex gap-2', className)}
      role="presentation"
      {...props}
    >
      <DescriptionLabel
        variant="body-bold"
        className="w-full max-w-56"
        id={labelId}
      >
        {label}
      </DescriptionLabel>
      <DescriptionSeparator />
      <DescriptionValue labelledById={labelId}>{value}</DescriptionValue>
    </div>
  )
}

type DescriptionLabelProps = HTMLAttributes<HTMLDListElement> &
  TextProps & {
    id: string
  }
export function DescriptionLabel({
  id,
  children,
  ...props
}: DescriptionLabelProps) {
  return (
    <Text as="dt" id={id} {...props}>
      {children}
    </Text>
  )
}

type DescriptionValueProps = HTMLAttributes<HTMLDListElement> &
  TextProps & {
    labelledById: string
  }
export function DescriptionValue({
  labelledById,
  children,
  className,
  ...props
}: DescriptionValueProps) {
  return (
    <Text
      as="dd"
      aria-labelledby={labelledById}
      className={clsx('overflow-wrap-anywhere', className)}
      {...props}
    >
      {children}
    </Text>
  )
}

export function DescriptionSeparator() {
  return <div role="presentation">:</div>
}
